
const ModuleName = "tfApp.span";

export default angular.module(ModuleName, [])
                      .name;
